module.exports = __webpack_public_path__ + "static/media/doctors.031dec84.png";